import {
  ClinicalConsultation,
  ClinicalConsultationAction,
  ClinicalConsultationActionType,
} from "core/types";

export const getClinicalConsultationActions = (
  consultation: ClinicalConsultation | null,
):
  | Record<string, never>
  | {
      [action in ClinicalConsultationActionType]: ClinicalConsultationAction;
    } =>
  consultation?.actions?.reduce(
    (acc, currentAction) => ({
      ...acc,
      [currentAction.action_type]: currentAction,
    }),
    {},
  ) || {};
